import axios from 'axios';
import { $get, $Post, $actGet, $actPost } from '../axios';
// import CloudServerApi from '../../../cloudserver/api';
// import ActConfApi from '../../../cloudserver/api/actConf';
// import ExchangeShopApi from '../../../cloudserver/api/exchangeShop';
import { errorTip } from '../utils';

// CloudServerApi($get);
// ActConfApi($actGet, $actPost);
// ExchangeShopApi($get);

// 获取开发者信息
export const getKfzInfo = params => {
  return $get('/creator/', { act: 'get_kfz_info', ...params });
};
// 获取验证码
export const getVercode = params => {
  return $get('/creator/', { act: 'get_vercode', ...params });
};
// 验证验证码
export const checkVercode = params => {
  return $get('/creator/', { act: 'auth_vercode', ...params });
};
// 获取首页数据
export const getHomeOverview = params => {
  return $get('/creator/', { act: 'get_home_overview', ...params });
};
// 获取首页banner
export const getBanners = params => {
  return $get('/creator/', { act: 'get_banners', ...params });
};
// 游戏打开链接，调用登录接口
export const loginGame = params => {
  return $get('/gate/', { act: 'login_game', ...params });
};
// 密码登录
export const loginWithPwd = params => {
  return $get('/gate/', { act: 'login_pw', ...params });
};
// 密码登录-获取邮箱验证码
export const getEmailCode = params => {
  return $get('/gate/', { act: 'get_email_code', ...params });
};
// 密码登录-获取邮箱验证码后再登录
export const loginEmailCode = params => {
  return $get('/gate/', { act: 'login_email_code', ...params });
};
//获取图片验证码
export const getPicCode = params => {
  return $get('/gate/', { act: 'get_icode', ...params });
};
// 验证码登录 - 获取验证码
export const getLoginCode = params => {
  return $get('/gate/', { act: 'login_code', ...params });
};
// 验证码登录 - 校验验证码
export const loginWithCode = params => {
  return $get('/gate/', { act: 'login_code_auth', ...params });
};
// 判断是否在云服白名单
export const isInCloudWhite = params => {
  return $get('/creator/', { act: 'in_cloud_white', ...params });
};
//独立密码二次认证
export const isCertify = params => {
  return $get('/creator/', { act: 'login_second_pwd', ...params });
};
//独立密码设置
export const judgeCertify = params => {
  return $get('/creator/', { act: 'set_second_pwd', ...params });
};
//独立密码修改
export const modCertify = params => {
  return $get('/creator/', { act: 'set_second_pwd', ...params });
};
//独立密码关闭
export const delCertify = params => {
  return $get('/creator/', { act: 'set_second_pwd', ...params });
};
//登录请求二次认证
export const repeatCertify = params => {
  return $get('/creator/', { act: 'status_second_pwd', ...params });
};
//获取学院信息
export const getCollege = params => {
  return $get('/pub/college/getRecommendCourse/', { ...params });
};
//获取公告信息
export const getAnnoce = params => {
  return $get('/pub/notice/list/', { ...params });
};
//获取热门搜索信息
export const getSearchData = params => {
  return $get('/pub/hot/hotKey/', { ...params });
};
//获取精选地图
export const getRecommonMap = params => {
  return $Post('/pub/mapHigh/searchMap/', params);
};
// 地图详情
export const getMapDetail = params => {
  return $get('/creator/', { act: 'get_map_overview', ...params });
};
window.$getMapDetail = getMapDetail;
//获取精选地图分类
export const getcommonMapfy = params => {
  return $get('/pub/mapHigh/allMapType/', { ...params });
};

export const getMyMaps = params => {
  return $actGet('/center/activity/', {
    act: 'get_map_by_uin',
    ...params,
  });
};

export const getMyActs = params => {
  return $actGet('/center/activity/', {
    act: 'activity_list',
    ...params,
  });
};
const isProd = process.env.NODE_ENV === 'production';
const actHost = isProd
  ? 'https://shequ.mini1.cn:8081'
  : 'https://indevelop.mini1.cn:8081';
export const getMapDetails = mapId => {
  let url = `${actHost}/miniw/map/?cmd=get_single_map_info&json=1&uin=&time=&token=&fn=${mapId}`;
  return new Promise((resolve, reject) => {
    return axios.get(url).then(res => {
      if (res.status === 200) {
        console.log('拉取到的地图详情：', res);
        const { data } = res;
        if (typeof data === 'string') {
          // 不存的地图 id
          errorTip('地图不存在，请输入正确的地图 id', 1000);
        } else {
          const { node, dir, thumb_md5, name } = data.select || data.normal;
          const imgUrl =
            data.urls[0].replace('%d', node) + node + '/' + dir + '/' + thumb_md5 + '.png';
          return resolve({ code: 0, data: { mapCover: imgUrl, mapName: name, mapId } });
        }
      } else {
        return reject({ code: 1, res });
      }
    });
  });
};

export const getAtcDetails = id => {
  return $actGet('/center/activity/', {
    act: 'register_info_by_activity_id',
    json: 1,
    id,
  });
};
export const getActWhiteState = () => {
  return $actGet('/center/activity/', {
    act: 'white_state',
    json: 1,
  });
};

// window.$getMapDetails = getMapDetails;
window.$getAtcDetails = getAtcDetails;
